import Http from "../network/Http";
import { isNotEmptyOrNull } from "../utils/common-utils";
import { StorageService } from "../utils/StorageUtils";
import timeLogsDB from "../utils/TimeLogsDB";
const ENDPOINTS = {
  aLlTasks: "/schoolai/task-progress/student",
  startTaskAPI: "/schoolai/task-progress/start-task",
  timeLogs: "/schoolai/task-progress/time-logs",
  fetchTimeLogs: "/schoolai/task-progress/time-logs/recent"
};

export const getALlTasks = async (taskStatus) => {
  try {
    let queryParams =
      taskStatus === "completed"
        ? `filterType=${taskStatus}&excludeParentLevelUp=true`
        : `filterType=${taskStatus}`;
    const response = await Http.post(`${ENDPOINTS.aLlTasks}?${queryParams}`);
    return response;
  } catch (error) {
    console.error(`At getALlTasks ${error}`);
  }
};

export const startTask = async (id) => {
  let data = {
    taskProgressId: id,
  };
  const response = await Http.post(
    ENDPOINTS.startTaskAPI,
    JSON.stringify(data)
  );
  return response;
};
export const getJourneyInfo = async (id, limit, offset) => {
  try {
    const res = await Http.get(
      `/lp-progress/v2?journey_id=${id}&limit=${limit}&offset=${offset}`
    );
    //const res = await Http.get("/lp-progress?journey_id=" + id);
    return res?.data;
  } catch (e) {
    return {};
  }
};

export const schoolUpdatesAPI = async () => {
  try {
    // console.log("studentId", studentId);
    let user_additional_details = StorageService.getItem(
      "user_additional_details"
    );
    user_additional_details =
      typeof user_additional_details === "object"
        ? user_additional_details
        : JSON.parse(user_additional_details);
    let sectionId = user_additional_details?.sectionId;
    let studentId = user_additional_details?.studentId;
    //console.log("sectionId", sectionId);
    const res = await Http.get(
      `/schoolai/school-updates?student_id=${studentId}&section_id=${sectionId}&limit=20`
    );
    return res?.data;
  } catch (e) {
    console.error("SCHOOL", e);
    return {};
  }
};

export const updateJourney = async ({
  journeyId,
  questionId,
  basketId,
  user_answer,
}) => {
  try {
    let body = { user_answer };
    const res = await Http.patch(
      `/lp-progress/update-journey?journey_id=${journeyId}&question_id=${questionId}&basket_id=${basketId}`,
      JSON.stringify(body)
    );
    return res?.data;
  } catch (e) {
    console.error("ERROR", e);
    return {};
  }
};

 export const syncTimeLogs = async () => {
    try {
      let timeLogsData = await timeLogsDB.getAllTimeLogs();
      if (timeLogsData && timeLogsData.length > 0) {
        await postTimeLogs(timeLogsData);
      }
    } catch (error) {
      console.error("Error syncing time logs:", error);
    }
  };

export const getTaskCountAPI = async () => {
  try {
    const res = await Http.get(`/schoolai/task-progress/student-task-count`);
    return res?.data;
  } catch (error) {
    console.log("Error", error);
    return {};
  }
};


export const postTimeLogs = async (timeLogsBody) => {
  try {
  
    const response = await Http.post(ENDPOINTS.timeLogs,
      timeLogsBody);
    return response;
  } catch (error) {
    console.error(`At getALlTasks ${error}`);
  }
};

export const getTimeLogs = async () => {
  try {
    const res = await Http.get(ENDPOINTS.fetchTimeLogs);
    return res?.data;
  } catch (error) {
    console.log("Error", error);
    return {};
  }
};